var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSendReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.75,
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80488 8C7.69944 8 7.59936 8.02596 7.50724 8.06879L12.1772 12.7268C12.3816 12.9309 12.6095 12.9311 12.8144 12.7268L17.4886 8.06387C17.3978 8.02247 17.2987 8 17.1951 8H7.80488ZM7.00838 8.80582C7.00293 8.85035 7 8.89705 7 8.9434V15.2328C7 15.7554 7.35898 16.1762 7.80488 16.1762H17.1951C17.641 16.1762 18 15.7554 18 15.2328V8.9434C18 8.89705 17.9971 8.85035 17.9916 8.80582L13.3384 13.4442C12.8561 13.925 12.1355 13.9258 11.6532 13.4442L7.00838 8.80582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSendReport);
export default __webpack_public_path__ + "static/media/icon-send-report.a9e00b9b233b485a89554ab670eb4780.svg";
export { ForwardRef as ReactComponent };